import { Controller } from '@hotwired/stimulus';

const DIRECT_APPLY_STORAGE_KEY = 'direct_apply_job';
const DIRECT_PRODUCT_PREFIX = 'direct-';

export default class extends Controller {
  /** @param {Event} event */
  capture(event) {
    const currentTarget = event.currentTarget;
    if (!(currentTarget instanceof HTMLElement)) return;

    const dataset = currentTarget.dataset;
    const productId = dataset.productId || dataset.product_id;
    const jobId = dataset.jobId || dataset.job_id;

    if (!jobId || !productId || !this._isDirectJob(productId)) return;

    const payload = {
      platform: 'direct',
      jobId,
      jobTitle: dataset.jobTitle || dataset.job_title,
      companyName: dataset.companyName || dataset.company_name,
      storedAt: Date.now(),
    };

    try {
      localStorage.setItem(DIRECT_APPLY_STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
      console.error('[DirectApplyContextController] failed to save direct apply context', error);
    }
  }

  /** @param {string} productId */
  _isDirectJob(productId) {
    return typeof productId === 'string' && productId.startsWith(DIRECT_PRODUCT_PREFIX);
  }
}
